<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Grace Marks Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                 <!-- <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="calculation_type"
                        :items="calculation_typeOptions"
                        item-text="label"
                        item-value="value"
                        label="Select Calculation Type"
                        outlined
                        persistent-hint
                        hint="Please select calculation type"
                    />
                </v-col> -->
                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div
          ">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <div class="scroll" v-if="leraner_marks!=''">
                <v-simple-table dense class="elevation-1" v-if="leraner_marks!=''" style="width:140%;" height="500px">
                    <thead>
                        <!-- <tr>
                        <th colspan="4"></th>
                        <th class=""  v-for="header,index in crs_list" :key="index" :colspan="crs_list_ass_details_size[index]">
                        <th colspan="3"></th>
                    </tr> -->
                        <tr>
                       <th>Sr.No.</th>
                       <th>Roll No.</th>
                       <th>Name</th>
                       <th>Division</th>
                       <th class=""  v-for="header,index in crs_list" :key="index">
                            <center>{{ header }}</center>
                        </th>
                        <th>Total</th>
                        <th> Total / Out Off</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in leraner_marks" :key="s.cid">
                            <td>{{ index+1 }}</td>
                       <td>{{ s.rollNo }}</td>
                       <td>{{ s.name }}</td>
                       <td>{{ s.division }}</td>
                        <td v-for="(m, index1) in s.marks" :key="index1">
                             <strong v-if="Object.values(s.grace_marks)[index1]!=0" style="color: brown;"> {{ Object.values(s.grace_marks)[index1] }} +  </strong>{{ m }} 
                        </td>
                        <!-- <td>{{ s.total_marks }} / {{ s.out_off_marks }}</td> -->
                        <td>{{ s.total_marks }}</td>
                        <td><v-btn class="button" x-small @click="savesinglecoursemarks(s)">save/update</v-btn></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            <center><v-btn v-if="leraner_marks!=''" class="button"
                    @click="saveallstudmarks(leraner_marks)">save/update</v-btn></center>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data() {
            return {
                overlay: false,
                selected: [],
                // extraBreadcrumbItems: [


                // ],
                hide_show:false,
                // breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                leraner_marks: [],
                standard: null,
                division: null,
                course: null,
                academicyear: null,
                org_basic_data: [],
                // crs_list_ass_details:[],
                // crs_list_ass_details_size:[],
                // crs_list_rubrics_details:[],
                // crs_list_rubrics_details_size:[],
                crs_list:[],
                
            //     calculation_type:null,
            //     calculation_typeOptions: [
            //     { label: "Regular", value: "regular" },
            //     { label: "Re-exam", value: "reexam" },
            //  ],
            };
        },

        methods: {
           
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            async saveallstudmarks(item) {
                const data = {
                    marks_data: item,
                };
                try {
                    const res = await axios.post("/Examination/saveallstudgracemarks", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Marks save successfully");
                        this.getreport();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                         this.showSnackbar("red", "Something Went Wrong!!!!!");
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                    this.showSnackbar("red", "Something Went Wrong!!!!!");
                } finally {
                    this.fetch_loader = false;
                }
            },
            async savesinglecoursemarks(item) {
                try {
                    const res = await axios.post("/Examination/savesinglestudgracemarks", item);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Grace Marks save successfully");
                        this.getreport();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.showSnackbar("red", "Something Went Wrong!!!!!");
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                     this.showSnackbar("red", "Something Went Wrong!!!!!");
                } finally {
                    this.fetch_loader = false;
                }
            },
            async getreport() {
                this.hide_show = false
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    div: this.div,
                    // calculation_type:this.calculation_type
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/Examination/graceMarksCalculation", data);
                    if (res.data.flag == "YES") {
                        this.leraner_marks = res.data.result;
                        // this.crs_list_ass_details = res.data.crs_list_ass_details
                        // this.crs_list_ass_details_size = res.data.crs_list_ass_details_size
                        this.crs_list = res.data.crs_list
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                // this.div_list = ["All"];
                // this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                // this.div_list.unshift("All");
                //this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    role: this.role,
                };
                axios
                    .post("/commonAPI/get_ay_std_div_wws_by_access",data)
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
 .scroll {
        overflow-x: scroll;
    }
    input[type="number"] {
        width: 70%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        /*  img {
            width: 100% !important;
        }*/
        body,
        tr,
        th,
        td {
            font-size: 14pt !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /*size: 15.5in 15.5in;*/
            size: 16in 20in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: hidden !important;
        }
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
    tr:hover {
    background-color: unset  !important;
    cursor: default !important;
    }
    .bg-yellow {
    background-color: yellow !important;
    font-weight: bold;
    }
    .bg-red {
        background-color: red !important; /* light red */
        font-weight: bold;
    }
    .bg-yellow:hover {
    background-color: yellow !important;

    }
    .bg-red:hover {
        background-color: red !important; /* light red */
    }
    
</style>
